module.exports = __webpack_public_path__ + "static/chuka-0909c42c5280e1d72bf0ed485769c6cb.png";